'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getManyValuesDimensions = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _getFlagsAndNotes = require('./table/getFlagsAndNotes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getManyValuesDimensions = exports.getManyValuesDimensions = function getManyValuesDimensions(dimensions, attributesSeries, customAttributes, combinations) {
  var combConceptsIds = R.pipe(R.pluck('concepts'), R.unnest)(combinations);
  return R.reduce(function (acc, dim) {
    if (dim.header || !R.length(dim.values)) {
      return acc;
    }
    var enhancedValues = R.map(function (val) {
      var attrSeries = R.propOr({}, dim.id + '=' + val.id, attributesSeries);
      if (R.isEmpty(attrSeries)) {
        return val;
      }
      var flags = (0, _getFlagsAndNotes.getFlagsAndNotes)(attrSeries, customAttributes);
      var hasAdvancedAttributes = R.pipe(R.omit(R.unnest([customAttributes.flags || [], customAttributes.notes || [], combConceptsIds])), R.complement(R.isEmpty))(attrSeries);
      return (0, _extends3.default)({}, val, { flags: flags, hasAdvancedAttributes: hasAdvancedAttributes });
    }, dim.values);
    return R.append(R.assoc('values', enhancedValues, dim), acc);
  }, [], dimensions);
};